export default __webpack_public_path__ + "static/club-gallery-2-8c99da77e8ae8dba0959132cf5c96d27.webp";